// extracted by mini-css-extract-plugin
module.exports = {"lastUpdatedText":"LastUpdated_lastUpdatedText__LGkN9"};